import { render, staticRenderFns } from "./TaxasEstabelecimento.vue?vue&type=template&id=5e649d4b&"
import script from "./TaxasEstabelecimento.vue?vue&type=script&lang=js&"
export * from "./TaxasEstabelecimento.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports